import { Navigate, RouteObject } from "react-router-dom";

export const generalLedgerRoutes: RouteObject = {
  id: "general-ledger",
  path: "general-ledger",
  children: [
    {
      id: "GLIntegrationList",
      index: true,
      lazy: async () => {
        const { GeneralLedgerIntegrationListPage } = await import(
          "features/general-ledger/GeneralLedgerIntegrationListPage"
        );
        return { Component: GeneralLedgerIntegrationListPage };
      },
      handle: {
        title: "Integrations",
      },
    },
    {
      id: "GLIntegration",
      path: ":integrationId",
      children: [
        {
          id: "GLIntegrationIndex",
          index: true,
          element: <Navigate to="profile" replace={true} />,
        },
        {
          id: "GLIntegrationView",
          lazy: async () => {
            const { GeneralLedgerIntegrationPage } = await import(
              "features/general-ledger/GeneralLedgerIntegrationPage"
            );
            return { Component: GeneralLedgerIntegrationPage };
          },
          children: [
            {
              id: "GLIntegrationProfile",
              path: "profile",
              lazy: async () => {
                const { ProfileTab } = await import(
                  "features/general-ledger/tabs/ProfileTab"
                );
                return { Component: ProfileTab };
              },
              handle: {
                title: "Profile",
              },
            },
            {
              id: "GLIntegrationEntries",
              path: "entries",
              lazy: async () => {
                const { EntriesTab } = await import(
                  "features/general-ledger/tabs/EntriesTab"
                );
                return { Component: EntriesTab };
              },
              handle: {
                title: "Entries",
              },
            },
          ],
        },
      ],
    },
  ],
};
